export var ICON_HEIGHT = 24;